import { render, staticRenderFns } from "./AlertTipsDialog.vue?vue&type=template&id=e58845a0&scoped=true"
import script from "./AlertTipsDialog.vue?vue&type=script&lang=js"
export * from "./AlertTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./AlertTipsDialog.vue?vue&type=style&index=0&id=e58845a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58845a0",
  null
  
)

export default component.exports